import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-40 border-t border-ink/10 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14 text-center"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( FAQ )</p>
          <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-4xl md:text-6xl lg:text-7xl">
            FAQ{" "}
            <span className="font-serif italic normal-case text-brand-ink">pertanyaan yang sering diajukan</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-ink/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 font-display font-bold text-base lg:text-lg text-left hover:no-underline hover:text-brand-ink transition-colors duration-300"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-sm lg:text-base text-ink/60 leading-relaxed pb-6"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
